import React from 'react';
import PropTypes from 'prop-types';
import TripBoardHit from '../TripBoardHit/TripBoardHit';
import './AddToTripBoard.less';

function AddToTripBoard({onTripBoardClicked, tripBoards}) {
    const tripBoardHits = tripBoards.map((tripBoard, index) => {
        const {boardId, name, listings = []} = tripBoard;
        const thumbnails = listings
            .filter((listing) => listing && listing.images)
            .reduce((currentThumbnails, listing) => {
                return currentThumbnails.concat([listing.images[0].c6_uri]);
            }, []);

        const onClick = (event) => {
            onTripBoardClicked(event, boardId);
        };

        return (
            <TripBoardHit
                key={`trip-board-hit-${index}`}
                onClick={onClick}
                tripBoardTitle={name}
                thumbnails={thumbnails}
            />
        );
    });

    return <div className="react-trip-board-button__add-to">{tripBoardHits}</div>;
}

AddToTripBoard.propTypes = {
    onTripBoardClicked: PropTypes.func,
    tripBoards: PropTypes.arrayOf(PropTypes.object)
};

AddToTripBoard.defaultProps = {
    onTripBoardClicked: () => {},
    tripBoards: []
};

export default AddToTripBoard;
